document.addEventListener('DOMContentLoaded', async function(){
    const adminInicio= document.querySelector('.admin-inicio');

    if(adminInicio){
        buscarPorFecha();
        
        let clientes= [];
        let clientesFiltrados= [];
        let feriados= []; 

        await obtenerClientes(); 
        await obtenerFeriadosAdmin();

        const divClientes= document.querySelector('.clientes');
        const inputBuscarCliente= document.querySelector('#nombre-cliente');
        inputBuscarCliente.addEventListener('input', buscarCliente);
        const inputBuscarFeriado= document.querySelector('#fecha-feriado');
        inputBuscarFeriado.addEventListener('input', buscarFeriado);


        function buscarPorFecha(){
            const inputFecha= document.querySelector('#fecha-turnos');
            if(inputFecha){
                inputFecha.addEventListener('input', function(e){
                    const fechaSeleccionada= e.target.value;
                    window.location= `?fecha=${fechaSeleccionada}`
                });
            }
        }

        async function obtenerClientes(){
            const url= '/api/obtener-clientes';
            const respuesta= await fetch(url);
            const resultado= await respuesta.json();
            clientes= resultado;
            formatearClientes(resultado);
        }

        async function obtenerFeriadosAdmin(){
            try {
                const url= '/api/obtener-feriados';
                const respuesta= await fetch(url);
                const feriadosDB = await respuesta.json(); 
                
                feriados = feriadosDB.map(objetoFeriado => {
                    return objetoFeriado.feriado; 
                });
            } catch (error) {
                console.error('Error al obtener feriados:', error);
            }
        }

        function formatearClientes(arrayClientes= []){
            clientes= arrayClientes.map(cliente=> {
                return{
                    nombre: `${cliente.nombre.trim()} ${cliente.apellido.trim()}`,
                    cortes: cliente.cortes,
                    id: cliente.id
                }
            })
        }

        function mostrarClientes(){
            while(divClientes.firstChild){
                divClientes.removeChild(divClientes.firstChild);
            }

            if(clientesFiltrados.length> 0){
                clientesFiltrados.forEach(cliente => {
                    const nombre= document.createElement('LI');
                    nombre.classList.add('clientes__cliente');
                    nombre.dataset.id= cliente.id
                    nombre.textContent= cliente.nombre;
                    nombre.onclick= seleccionarCliente;
                    divClientes.appendChild(nombre);
                });
            }else{
                    const noResultados = document.createElement('P')
                    noResultados.classList.add('clientes__cliente--no-resultado')
                    noResultados.textContent = 'No hay resultados para tu búsqueda'
                    divClientes.appendChild(noResultados)      
                }
        }

        function buscarCliente(e){
            const busqueda= e.target.value;
            if(busqueda.length >= 2){
                const q = busqueda.toLowerCase();
                clientesFiltrados= clientes.filter(cliente=> {
                    if(cliente.nombre.toLowerCase().includes(q)){
                        return cliente;
                    }
                })
            }else{
                clientesFiltrados= [];
            }
            mostrarClientes();
        }

        async function seleccionarCliente(e){
            const id= e.target.dataset.id;
            const url= `/api/buscar-cliente?id=${id}`;
            const respuesta= await fetch(url);
            const cliente= await respuesta.json();
            mostrarCliente(cliente);
        }

        function mostrarCliente(cliente){
            while(divClientes.firstChild){
                divClientes.removeChild(divClientes.firstChild);
            }
            const divCliente= document.querySelector('#cliente-seleccionado');
            divCliente.classList.remove('ocultar');
            while(divCliente.firstChild){
                divCliente.removeChild(divCliente.firstChild);
            }
            if(cliente.cortes=== '' || cliente.cortes=== null){
                cliente.cortes=0;
            }

            const divNombre= document.createElement('DIV');
            divNombre.classList.add('cliente__campo');
            const tituloNombre= document.createElement('P');
            tituloNombre.classList.add('cliente__campo--titulo');
            tituloNombre.textContent= 'Cliente: ';
            const nombreCliente= document.createElement('P');
            nombreCliente.classList.add('cliente__campo--nombre');
            nombreCliente.textContent= cliente.nombre;
            divNombre.appendChild(tituloNombre);
            divNombre.appendChild(nombreCliente);

            const divCortes= document.createElement('DIV');
            divCortes.classList.add('cliente__campo');
            divCortes.classList.add('campo');
            const tituloCortes= document.createElement('P');
            tituloCortes.classList.add('cliente__campo--titulo');
            tituloCortes.textContent= 'Cortes: ';
            const cortesCliente= document.createElement('INPUT');
            cortesCliente.type='number';
            cortesCliente.value= cliente.cortes;
            cortesCliente.id = 'input-cortes-cliente';
            divCortes.appendChild(tituloCortes);
            divCortes.appendChild(cortesCliente)

            const inputSubmit= document.createElement('BUTTON');
            inputSubmit.classList.add('boton-guardar');
            inputSubmit.textContent= 'Guardar';
            inputSubmit.onclick= function(){
                guardarCortes(cliente);
            };

            divCliente.appendChild(divNombre);
            divCliente.appendChild(divCortes);
            divCliente.appendChild(inputSubmit);
        }

        async function guardarCortes(cliente){
            const inputCortes = document.querySelector('#input-cortes-cliente');
            const nuevoValorCortes = inputCortes.value;
            const url= '/api/guardar-cortes';
            const datos= new FormData();
            const {id}= cliente;
            datos.append('id', id);
            datos.append('cortes', nuevoValorCortes);
            const respuesta= await fetch(url, {
                method: 'POST',
                body: datos
            })
            const resultado= await respuesta.json();
            if(resultado){
                window.location.href = "/admin"; 
            }
        }

        function buscarFeriado(e){
            const divFeriado= document.querySelector('#feriado-div');
            while(divFeriado.firstChild){
                divFeriado.removeChild(divFeriado.firstChild);
            }

            const diaSeleccionado= e.target.value; 
            if (!diaSeleccionado) return;

            const esFeriadoExistente = feriados.includes(diaSeleccionado);
            
            const fecha = new Date(diaSeleccionado.replace(/-/g, '/'));
            const opciones = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
            const fechaFormateada = fecha.toLocaleDateString('es-ES', opciones);

            const dia= document.createElement('P');
            dia.classList.add('feriado-dia');
            dia.textContent= fechaFormateada;
            divFeriado.appendChild(dia);


            let boton;
            if (esFeriadoExistente) {
                boton = document.createElement('BUTTON');
                boton.classList.add('submit-feriado', 'boton-eliminar');
                boton.textContent= 'Eliminar Feriado';
                
                boton.onclick = function() {
                    eliminarFeriado(diaSeleccionado); 
                };
            } else {
                boton = document.createElement('BUTTON'); 
                boton.classList.add('submit-feriado');
                boton.textContent= 'Marcar Feriado';
                
                boton.onclick = function() {
                    marcarFeriado(diaSeleccionado);
                };
            }
            
            divFeriado.appendChild(boton);
        }

        async function marcarFeriado(diaSeleccionado){
            const datos= new FormData();
            datos.append('feriado', diaSeleccionado);
            try {
                const url= 'api/marcar-feriado';
                const respuesta= await fetch(url, {
                    method: 'POST',
                    body: datos
                })
                const resultado= await respuesta.json();
                if(resultado.resultado){
                    Swal.fire({
                        title: "Feriado guardado",
                        text: "El feriado se guardo correctamente",
                        icon: "success",
                    }).then(()=> location.href= '/admin');
                }
            } catch (error) {
                Swal.fire({
                    title: "Error",
                    text: "Hubo un error al guardar el feriado",
                    icon: "error",
                    });
            }
        }

        async function eliminarFeriado(diaSeleccionado){
            const { isConfirmed } = await Swal.fire({
                title: "¿Estás seguro?",
                text: "Un feriado eliminado volverá a estar disponible para citas.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sí, eliminar",
                cancelButtonText: "Cancelar"
            });

            if (isConfirmed) {
                const datos= new FormData();
                datos.append('feriado', diaSeleccionado); 

                try {
                    const url= 'api/eliminar-feriado';
                    const respuesta= await fetch(url, {
                        method: 'POST',
                        body: datos
                    })
                    const resultado= await respuesta.json();

                    if(resultado.resultado){
                        Swal.fire({
                            title: "Eliminado",
                            text: "El feriado ha sido eliminado correctamente.",
                            icon: "success",
                        }).then(()=> location.href= '/admin');
                    } else {
                         Swal.fire({
                            title: "Error",
                            text: "No se pudo eliminar el feriado.",
                            icon: "error",
                        });
                    }
                } catch (error) {
                    Swal.fire({
                        title: "Error",
                        text: "Hubo un error al comunicarse con el servidor.",
                        icon: "error",
                    });
                }
            }
        }
    }
})